module.exports = __webpack_public_path__ + "img/logo-white.a7595b8c.svg";